import { rootReducer } from '..';

type RootState = ReturnType<typeof rootReducer>;

export const getIsAnimation = (state: RootState) => {
  return state.animation.isActive;
};
